// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChangeAccountVerificationModal-module__wrapper","btnsWrapper":"ChangeAccountVerificationModal-module__btnsWrapper","modal":"ChangeAccountVerificationModal-module__modal"};